import Store from '@ember-data/store';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import FundsService from 'donor-elf-web/services/funds-service';
import PowerMenuService from 'donor-elf-web/services/power-menu';

export default class AdminUsersShowController extends Controller {
  @service declare flashMessages: any;
  @service declare fundsService: FundsService;
  @service declare powerMenu: PowerMenuService;
  @service declare store: Store;

  get showResendActivationEmail() {
    return isEmpty(this.model.user.currentSignInAt);
  }

  @action
  templateDidInsert() {
    this.powerMenu.prependOptionsFn('admin-users-show', this.powerMenuOptions);
  }

  @action
  templateWillDestroy() {
    this.powerMenu.removeOptions('admin-users-show');
  }

  @action
  powerMenuOptions() {
    return [
      {
        label: 'View Selected Fund',
        fn: this.viewSelectedFund,
      },
    ];
  }

  @action
  viewSelectedFund() {
    this.fundsService.viewFund(this.model.user.selectedFundId);
  }

  @action
  writeFindUserInRubyToClipboard() {
    window.navigator.clipboard.writeText(
      `user = User.find(${this.model.user.id})`,
    );
  }
}
